export default "__VITE_ASSET__4d6a44e0__"